export const content = [
  {
    id: 1,
    title: "My Website",
    link: "https://agrpaavan-portfolio.netlify.app/",
    image: "/linkImages/person.svg",
  },
  {
    id: 2,
    title: "GitHub",
    link: "https://github.com/AgrPaavan",
    image: "/linkImages/github.svg",
  },
  {
    id: 3,
    title: "LinkedIn",
    link: "https://www.linkedin.com/in/paavan-agrawal-28186a201/",
    image: "/linkImages/linkedin.svg",
  },
  {
    id: 4,
    title: "Instagram",
    link: "https://www.instagram.com/paavanagr/",
    image: "/linkImages/instagram.svg",
  },
];
export default content;
